

import React, { useState } from "react";
import { Tabs, Tab, Box, IconButton, Typography } from "@mui/material";
import { Close } from "@mui/icons-material";
import MembershipGroupsAll from "./MembershipGroupsAll";
import MembershipGroupsDetails from "./MembershipGroupsDetails";
import MembershipGroupsCreate from "./MembershipGroupsCreate";


const MembershipGroupsTabs = () => {
  const [tabs, setTabs] = useState([{ label: "All Groups", component: "allExercises" },{ label: "+ Create Group", component: "addExercises" }]);
  const [selectedTab, setSelectedTab] = useState(0);

  // Function to Add a New Warehouse Tab
  const handleAddTab = (exercise) => {
    const existingTab = tabs.find((tab) => tab.id === exercise.group_id);
    if (!existingTab) {
      setTabs([...tabs, { id: exercise.group_id, label: exercise.group_name, component: "exercisesDetails", data: exercise }]);
      setSelectedTab(tabs.length);
    } else {
      setSelectedTab(tabs.findIndex((tab) => tab.id === exercise.group_id));
    }
  };

  const handleCloseTab = (index) => {
    const newTabs = tabs.filter((_, i) => i !== index);
    
    if (index === selectedTab) {
      if (newTabs.length > 2) {
        setSelectedTab(Math.max(0, index - 1)); // Move to previous tab if available
      } else {
        setSelectedTab(0); // Reset to "All Exercises" if only default tabs remain
      }
    }
  
    setTabs(newTabs);
  };
  
  return (
    <Box sx={{ width: "100%" }}>
      {/* MUI Tabs */}
      <Tabs value={selectedTab} onChange={(e, newValue) => setSelectedTab(newValue)} variant="scrollable" scrollButtons="auto">
        {tabs.map((tab, index) => (
          <Tab
            key={index}
            label={
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography>{tab.label}</Typography>
                {index > 1 && (
                  <IconButton size="small" onClick={() => handleCloseTab(index)} sx={{ ml: 1 }}>
                    <Close fontSize="small" />
                  </IconButton>
                )}
              </Box>
            }
          />
        ))}
      </Tabs>

      {/* Tab Content */}
      <Box sx={{ p: 2 }}>
        {tabs[selectedTab].component === "allExercises" && <MembershipGroupsAll onExerciseClick={handleAddTab} />}
        {tabs[selectedTab].component === "addExercises" && <MembershipGroupsCreate />}
        {tabs[selectedTab].component === "exercisesDetails" && <MembershipGroupsDetails groupDetails={tabs[selectedTab].data} />}
      </Box>
    </Box>
  );
};

export default MembershipGroupsTabs;
